module.exports = __webpack_public_path__ + "img/amazon.70564003.jpg";